import { Col, Form, Row } from 'antd';
import { Button, RadioGroup } from 'components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';
import { useForm } from 'antd/lib/form/Form';
import CarrierUsers from './carrierUsers';
import { cloneDeep, size } from 'lodash';
import { extractValueFromEvent } from 'utils/helpers';
import styles from './SubTab2.module.scss';

const SubTab2 = ({ disabled, extended }) => {
  const [totalShareholderPercentage, setTotalShareholderPercentage] = useState(null);
  const carrier = useSelector(state => state.forms.carrier);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode;
  const [form] = useForm();
  const dispatch = useDispatch();

  const carrierUsers = useSelector(
    state => state.forms.carrier.carrierUsers
  ) || [
    {
      shareholderName: null,
      shareholderVat: null,
      shareholderCountry: null,
      shareholderPercentage: null,
    },
  ];

  const handleChange = ({ key, type, event }) => {
    let newValue = extractValueFromEvent(type, event);

    if (type === 'radio' && key === 'hasShareholdersFlag') {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'errorCheckHandlingShareholders',
          value: true,
        })
      );
      if (event.target.value === false) {
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'carrierUsers',
            value: null,
          })
        );
      } else {
        const fixedUser = [
          {
            shareholderName: carrier.companyName,
            shareholderVat: carrier.legalVat,
            shareholderCountry: null,
            shareholderPercentage: null,
          },
        ];
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'carrierUsers',
            value: fixedUser,
          })
        );
      }
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  const handleChangeUsers = ({ key, value }) => {
    dispatch(updateFormField({ group: 'carrier', key, value }));
  };

  const addMore = () => {
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'carrierUsers',
        value: [
          ...carrierUsers,
          {
            shareholderName: null,
            shareholderVat: null,
            shareholderCountry: null,
            shareholderPercentage: null,
          },
        ],
      })
    );
  };

  const removeUser = key => {
    const value = carrierUsers.filter((_, index) => index !== key);
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'carrierUsers',
        value,
      })
    );
  };

  useEffect(() => {
    if (size(carrierUsers) < 1) {
      addMore();
    }
  }, [carrierUsers]);

  const renderUsers = () =>
    carrierUsers.map((item, index) => (
      <CarrierUsers
        item={item}
        key={index}
        index={index}
        disabled={viewMode}
        removeUser={removeUser}
        update={({ key, newValue, index }) => {
          const newUsers = [...carrierUsers];
          newUsers[index] = {
            ...newUsers[index],
            [key]: newValue,
          };
          handleChangeUsers({
            key: 'carrierUsers',
            value: newUsers,
          });
        }}
        carrierUsers={carrierUsers}
        addUsers={addMore}
      />
    ));

  useEffect(() => {
    var newValues = cloneDeep(carrierUsers);
    form.setFieldsValue({ carrierUsers: newValues });

    const fieldsToValidate = newValues.flatMap((user, index) => {
      const {
        shareholderName,
        shareholderVat,
        shareholderCountry,
        shareholderPercentage,
      } = user;

      // Skip validation if all three fields are empty
      const isAllEmpty =
        !shareholderName &&
        !shareholderVat &&
        !shareholderCountry &&
        !shareholderPercentage;
      if (isAllEmpty) return [];

      // Otherwise, include the relevant fields for validation
      return [
        ['carrierUsers', index, 'shareholderName'],
        ['carrierUsers', index, 'shareholderVat'],
        ['carrierUsers', index, 'shareholderCountry'],
        ['carrierUsers', index, 'shareholderPercentage'],
      ];
    });

    form.validateFields(fieldsToValidate);
  }, [carrier.carrierUsers]);

  useEffect(() => {
    form.setFieldsValue({ carrierUsers: carrierUsers });
  }, [carrier.carrierUsers]);

  
  useEffect(()=> {
    const total = carrierUsers.reduce((sum, s) => {
        const val = Number(s.shareholderPercentage);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);
    
      setTotalShareholderPercentage(total)       
  },[carrierUsers])
  

  return (
    <div
      className={styles.subTab2CarrierUsers}
      style={{ minHeight: 600, marginBottom: 200 }}
    >
      <Form
        form={form}
        name="shareHolders"
        initialValues={{ ...carrier }}
        preserve={false}
        className={styles.carrierUsersForm}
      >
        <div
          className="carrier-data-form "
          style={{ width: '100%', display: 'inline-block' }}
        >
          <p className="mt-6 mr-0 color-purple-3 text-bold font-size-24">
            Στοιχεία Εταίρων/Μετόχων Φορέα
          </p>
          <div className={styles['light-purple-boxing']}>
            <p className="no-margins font-size-19">
              <b>
                Με ατομική μου ευθύνη και γνωρίζοντας τις κυρώσεις, που
                προβλέπονται από τις διατάξεις της παρ. 6 του άρθρου 22 του Ν.
                1599/1986, δηλώνω ότι:
              </b>
              <br />
              Με την ιδιότητα μου ως Νόμιμος Εκπρόσωπος ή Υπεύθυνος Κανονιστικής
              Συμμόρφωσης της Επιχείρησης{' '}
              <b>{carrier?.companyName ?? 'ΕΠΩΝΥΜΙΑ'}</b> με Α.Φ.Μ.{' '}
              <b>{carrier?.legalVat ?? 'ΑΦΜ'}</b>, δηλώνω υπεύθυνα ότι τα
              κατωτέρω πρόσωπα δύνανται να θεωρούνται ως Εταίροι/Μέτοχοι της εν
              λόγω επιχείρησης.
            </p>
          </div>

          <Row gutter={{ xs: 8, sm: 12, md: 16, lg: 22 }} className="mt-3">
            <Col span={24}>
              <RadioGroup
                label={<div style={{fontWeight: "bold"}}>Υπάρχουν άλλοι Εταίροι/Μέτοχοι στον Φορέα της Επένδυσης;</div>}
                options={[
                  { label: 'Ναι', id: 'yesOption', value: true },
                  { label: 'Όχι', id: 'noOption', value: false },
                ]}
                name="hasShareholdersFlag"
                checked={carrier?.hasShareholdersFlag}
                value={carrier?.hasShareholdersFlag}
                id="hasShareholdersFlag"
                disabled={viewMode}
                onChange={event =>
                  handleChange({ key: event.target.name, type: 'radio', event })
                }
              />
            </Col>
          </Row>
          {carrier?.hasShareholdersFlag === true && (
            <Row
              gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
              className="shareHoldersWrapper"
            >
              <Col span={24}>{renderUsers()}</Col>
              {!viewMode && (
                <>
                  <Col>
                    { (totalShareholderPercentage !== 100 ) && (
                      <>
                        <div className="ant-form-item-explain-error">
                          Το άθροισμα των ποσοστών Συμμετοχής πρέπει να είναι 100%
                        </div>
                      </>
                    )}
                  </Col>
                  <Col span={24}>
                    <Button
                      className="mt-2 addMoreBtn"
                      label={'Προσθήκη'}
                      onClick={addMore}
                    />
                  </Col>
                </>
              )}
            </Row>
          )}
        </div>
      </Form>
    </div>
  );
};

export default SubTab2;
